@let ctx =
  {
    setupPhase: (setupPhase$ | async),
    loadingDialog: (loadingDialog$ | async),
    coupledConnector: (coupledConnector$ | async),
  };

<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Dropbox</div>
  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    @if (isCopyConfigurationButtonVisible) {
      <blaze-copy-connector-config-env-button
        [coupledConnector]="ctx.coupledConnector"
        (copyConfiguration)="copyConfiguration($event)"
      />
    }
    @if (isAuthorizeButtonVisible) {
      <button
        [disabled]="ctx.loadingDialog || loading()"
        (click)="goToAuth()"
        blazeBarButton="secondary"
      >
        authorize
      </button>
    }
    @if (isFormButtonVisible) {
      <button
        [disabled]="ctx.loadingDialog || loading()"
        (click)="goToForm()"
        blazeBarButton="secondary"
      >
        show form
      </button>
    }
    @if (isSaveButtonVisible) {
      <button
        [disabled]="connectorForm.invalid || ctx.loadingDialog || loading()"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        {{ saveButtonLabel }}
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    @if (ctx.loadingDialog === false) {
      <div class="flex flex-col items-center">
        @switch (ctx.setupPhase) {
          @case (SetupPhase.Authorization) {
            <ng-template [ngTemplateOutlet]="authorizationTpl" />
          }
          @case (SetupPhase.PopupOpened) {
            <ng-template [ngTemplateOutlet]="popupOpenedTpl" />
          }
          @case (SetupPhase.ConnectorCreation) {
            <ng-template [ngTemplateOutlet]="connectorCreationTpl" />
          }
        }
      </div>
    }
    <blaze-element-loading-indicator [isVisible]="ctx.loadingDialog" />
  </div>
</blaze-panel>

<ng-template #authorizationTpl>
  <h3 class="mb-16">To create connector sign in to Dropbox</h3>
  <button
    blazeButton
    blazeIconButtonSize="xl"
    class="bd"
    [disabled]="!authorizationUrl"
    (click)="connect()"
    >Sign in to Dropbox</button
  >
</ng-template>

<ng-template #popupOpenedTpl>
  <h3 class="mb-16">Please follow instructions in opened window.</h3>
  <button blazeButton (click)="focusOpenedWindow()"> Focus window </button>
</ng-template>

<ng-template #connectorCreationTpl>
  <form class="flex flex-col w-full" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
    <div class="form-control mb-22">
      <label class="field-label bd-field-label required">Name your connector</label>
      <input formControlName="connectorName" name="connectorName" class="bd-text-input tall" />
    </div>
  </form>
</ng-template>
